module.exports = __webpack_public_path__ + "img/readMoreNew.c2718df8.svg";